export default __webpack_public_path__ + "static/2-5e439c4e13f0e0c5187c432ce15998d8.jpeg";